import { api } from "@/services/api"
import { useMutation, useQueryClient } from "@tanstack/react-query"

interface UpdateChallengeStudySession {
  sessionId: string
  activityId: string
  answerIndex?: number
  elapsedTimeInSeconds?: number
}

export default function useUpdateChallengeStudySession() {
  const queryClient = useQueryClient()
  const mutation = useMutation({
    mutationFn: ({ sessionId, activityId, ...data }: UpdateChallengeStudySession) => {
      return api.odin.activities.challenges.studySession.update(activityId, sessionId, data)
    },
    onSettled() {
      queryClient.invalidateQueries({
        queryKey: ["planner-get-weekly-objectives", "study-get-activities"],
      })
    },
  })

  return mutation
}
